export const domainName = [
    { value: 'legal', label: 'Legal' },
    { value: 'healthcare', label: 'Healthcare and Medical' },
    { value: 'finance', label: 'Finance and Banking' },
    { value: 'government', label: 'Government and Public Administration' },
    { value: 'education', label: 'Education' },
    { value: 'technology', label: 'Technology and Software' },
    { value: 'marketing', label: 'Marketing and Advertising' },
    { value: 'ecommerce', label: 'E-commerce and Retail' },
    { value: 'tourism', label: 'Tourism and Travel' },
    { value: 'hr', label: 'Human Resources' },
    { value: 'research', label: 'Scientific Research' },
    { value: 'media', label: 'Entertainment and Media' },
    { value: 'manufacturing', label: 'Manufacturing and Engineering' },
    { value: 'pharmaceutical', label: 'Pharmaceutical Industry' },
    { value: 'international', label: 'International Organizations' }
];
